
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"12","fill":"none","stroke":"#A6A9EB","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.667 1H16.5M5.667 6H16.5M5.667 11H16.5M1.5 1h.008M1.5 6h.008M1.5 11h.008"}})])
          )
        }
      }
    